import { Stripe } from '@stripe/stripe-js'

export const confirmPendingSetupIntent = async (
  stripe: Stripe,
  intent: string
) => {
  // We are ignoring possible confirmCardPayment and confirmCardSetup
  // errors because they will be handled by the backend.
  if (intent.startsWith('pi_')) {
    await stripe.confirmCardPayment(intent)
  } else if (intent.startsWith('seti_')) {
    await stripe.confirmCardSetup(intent)
  }
}
